// @flow
import React from 'react';

import mainCover from 'assets/articles/main_cover.png';
import styles from './styles.module.scss';

import FAQQuestion from '../../components/FAQQuestion';
import FooterABC from '../../containers/Footer/footerABC';

import questions from './questions';
import MetaDecorator from '../../utils/MetaDecorator';
import { faq } from '../../utils/MetaDecorator/meta';

const QUESTIONS = questions;

const ResultsFAQ = () => (
  <section className={styles.faqContainer}>
    <MetaDecorator
      description={faq.description}
      title={faq.title}
    />
    <div className={styles.faqContent}>
      <div className={styles.faqIndent} />
      <div className={styles.faqWrapper}>
        <div className={styles.faqCover}>
          <img
            className={styles.articlePreview__image}
            src={mainCover}
            alt="faq cover"
          />
        </div>
        {QUESTIONS.map((question) => (
          <FAQQuestion
            text={question.text}
            title={question.title}
            combinations={question.combinations}
          />
        ))}
      </div>
      <div className={styles.faqIndent} />
    </div>
    <div className={styles.footerABC}>
      <FooterABC />
    </div>
  </section>
);

export default ResultsFAQ;
